import { getContext } from '@fiverr-private/fiverr_context';

export const isWzdSource = () => {
    const {
        queryParameters: { source },
    } = getContext();

    return source === 'wzd';
};
